if (typeof window.stockmansteaksDiscountSync === "undefined") {
  window.stockmansteaksDiscountSync = (() => {
    let queueTimeout = null;
    const MODULE_NAME = 'Stockman Steaks Discount Sync';
    const FREE_ITEM_VARIANT_ID = 41589553791021;

    const printLog = (message) => {
      console.log(
        `%c${MODULE_NAME}`, // Module Name
        'font-weight: bold; color: #000; background:rgb(238, 208, 242); border-radius: 3px; padding-left: 5px; padding-right: 5px;',
        message,
      );
    };

    const getFreeSubscriptionItems = (line_items) => {
      const freeItems = [];

      // The free subscription item is identified by the property "_FREE_SUBSCRIPTION_ITEM" with value "Yes"
      if (!line_items || line_items.length === 0) {
        return freeItems;
      }

      return line_items.filter(line_item => {
        return line_item.properties && line_item.properties._FREE_SUBSCRIPTION_ITEM?.toLowerCase() === "yes";
      });
    }

    const hasAtLeastOneSubscriptionItem = (line_items) => {
      // Check if there is at least one subscription item in the cart
      if (!line_items || line_items.length === 0) {
        return false;
      }
      
      for (let i = 0; i < line_items.length; i++) {
        const line_item = line_items[i];
        if (line_item.selling_plan_allocation?.selling_plan?.id) {
          return true;
        } else if (line_item.title.toLowerCase().includes('Subscription')) {
          return true;
        }
      }

      return false;
    }
    
    const main = async (cartResponse) => {
      const items = cartResponse.items;
      
      if (!items || items.length === 0) {
        return;
      }

      const hasAtLeastOneSubscriptionItemStatus = hasAtLeastOneSubscriptionItem(items);
      const freeSubscriptionItems = getFreeSubscriptionItems(items);

      if (!hasAtLeastOneSubscriptionItemStatus && freeSubscriptionItems.length > 0) {
        // Remove the all free subscription items from the cart
        const payload = freeSubscriptionItems.reduce((acc, item) => {
          acc[item.id] = 0; // Set the quantity to 0 to remove the item
          return acc;
        }, {});

        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: payload,
            sections: "cart-live-region-text,cart-icon-bubble,main-cart-items,main-cart-footer",
          }),
        })
          .then((response) => response.json());

        window.stockmansteaks.replaceSections(response);
        window.stockmansteaks.toggleCartEmpty(response.item_count === 0);

        printLog(`Free subscription item(s) removed from cart.`);
      } else if (hasAtLeastOneSubscriptionItemStatus && !freeSubscriptionItems.length) {
        await window.stockmansteaks.addItem({
          variantId: FREE_ITEM_VARIANT_ID,
          quantity: 1,
          properties: {
            _FREE_SUBSCRIPTION_ITEM: "Yes",
          },
          ignoreAddonsModal: true,
          refreshedSections: "cart-notification-product,cart-notification-button,cart-icon-bubble,main-cart-items",
        })

        printLog(`Free subscription item added to cart.`);
      } else if (hasAtLeastOneSubscriptionItemStatus && freeSubscriptionItems.length > 0) {
        const payload = {};

        // Loop through and change the free subscription item quantity to 1
        freeSubscriptionItems.forEach((item) => {
          if (item.quantity > 1) {
            payload[item.id] = 1;
          } 
        });

        if (Object.values(payload).length <= 0) {
          return;
        }

        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: payload,
            sections: "cart-live-region-text,cart-icon-bubble,main-cart-items,main-cart-footer",
          }),
        })
          .then((response) => response.json());

        window.stockmansteaks.replaceSections(response);
        window.stockmansteaks.toggleCartEmpty(response.item_count === 0);

        printLog(`Free subscription item altered to cart.`);
      }
    };

    const overrideFetch = () => {
      // Intercept the fetch method
      var originalFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0];

        if (url === "/cart.json" || url === "/cart.js") {
          return originalFetch.apply(this, arguments).then((response) => {
            const clonedResponse = response.clone();
            clonedResponse.json().then((data) => {
              if (data && data.items) {
                // Clear the previous timeout if it exists
                if (queueTimeout) {
                  clearTimeout(queueTimeout);
                }

                queueTimeout = setTimeout(() => {
                  main(data);
                }, 1000);
              }
            });
            
            return response;
          });
        }

        return originalFetch.apply(this, arguments);
      };
    };

    const init = () => {
      overrideFetch();
    };

    init();

    printLog("stockman-steaks-discount-sync.js loaded");

    return {
      getFreeSubscriptionItems,
      hasAtLeastOneSubscriptionItem,
      processCartResponse: main,
    }
  })();
}
